// extracted by mini-css-extract-plugin
export default {"divider":"PersonalData_divider__zaASF"};